export const resolveSocketAuthPayload = async ({ getToken, testAuthToken, userID }) => {
	let token = String(testAuthToken || '').trim();
	if (!token && typeof getToken === 'function') {
		try {
			token = String(await getToken() || '').trim();
		} catch (_) {
			token = '';
		}
	}

	const safeUserID = String(userID || '').trim();
	if (!token && !safeUserID) {
		return null;
	}

	return {
		token,
		userID: safeUserID
	};
};

